import { createRouter, createWebHistory } from 'vue-router'
import { store } from '../store/index'
import routes from '../routes'
import { config } from '../../config'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // console.log({ to, from, maintenancemode: config.maintenancemode })
  if (to.query.t) {
    store.dispatch('switchto', { token: to.query.t })
    store.dispatch('setadmin', { asadmin: 1 })
  }
  if (
    config.maintenancemode &&
    to.name !== 'maintenancemode' &&
    store.state.asadmin !== 1
  ) {
    next('/maintenancemode')
  } else {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (store.getters.isLoggedIn) {
        next()
        return
      }
      next('/login')
    } else {
      next()
    }
  }
})

export default router
